"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transform = exports.deserializeAsync = exports.deserialize = exports.validateAsync = exports.validate = exports.serialize = void 0;
const result_1 = require("@leavy/result");
const transformer = require("./base/transformer");
const validator = require("./base/validator");
const decorators_1 = require("./decorators");
exports.serialize = transformer.serialize;
function validate(ctor, value, options) {
    const transformed = transform(ctor, value, options);
    const validationErrors = validator.validateSync(transformed, options === null || options === void 0 ? void 0 : options.validator);
    if (validationErrors.length > 0)
        return result_1.Bad.validationFailed(validationErrors);
    return result_1.Ok(transformed);
}
exports.validate = validate;
async function validateAsync(ctor, value, options) {
    const transformed = transform(ctor, value, options);
    const validationErrors = await validator.validate(transformed, options === null || options === void 0 ? void 0 : options.validator);
    if (validationErrors.length > 0)
        return result_1.Bad.validationFailed(validationErrors);
    return result_1.Ok(transformed);
}
exports.validateAsync = validateAsync;
function deserialize(ctor, json, options) {
    const value = JSON.parse(json);
    if (value == null)
        return result_1.Ok(null);
    return validate(ctor, value, options);
}
exports.deserialize = deserialize;
async function deserializeAsync(ctor, json, options) {
    const value = JSON.parse(json);
    if (value == null)
        return result_1.Ok(null);
    return validateAsync(ctor, value, options);
}
exports.deserializeAsync = deserializeAsync;
function transform(ctor, valueToTransform, options) {
    if (typeof valueToTransform !== "object")
        throw new Error(`Only objects can be transformed. Found type: ${typeof valueToTransform}`);
    if (valueToTransform == null)
        throw new Error("Can't transform a null value");
    const meta = decorators_1.readValidationMetadata(ctor);
    if (!meta) {
        return transformer.plainToClass(ctor, valueToTransform, options === null || options === void 0 ? void 0 : options.transformer);
    }
    const nonTransformableProperties = Object.entries(meta.ignore)
        .filter(([k, v]) => v)
        .map(([k]) => k);
    const valueProperties = Object.keys(valueToTransform);
    const transformableSubset = {};
    for (const prop of valueProperties) {
        if (!nonTransformableProperties.includes(prop)) {
            transformableSubset[prop] = valueToTransform[prop];
        }
    }
    const finalValue = transformer.plainToClass(ctor, transformableSubset, options === null || options === void 0 ? void 0 : options.transformer);
    for (const prop of nonTransformableProperties) {
        finalValue[prop] = valueToTransform[prop];
    }
    return finalValue;
}
exports.transform = transform;
//# sourceMappingURL=validator.js.map